export const Status = {
  OPEN: 'OPEN',
  STARTED: 'STARTED',
  FINISHED: 'FINISHED',
  LOADING: 'LOADING',
}
